import { combineReducers } from "redux";
import ui from "./ui";

const rootReducer = combineReducers({
  ui: ui,
});

export default rootReducer;
